/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Offercard_Comingsoon2Inputs */

const id_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segera Hadir`)
};

const ms_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akan Datang`)
};

const da_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommer Snart`)
};

const de_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demnächst`)
};

const en_us2_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming Soon`)
};

const es_es2_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximamente`)
};

const es_mx2_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximamente`)
};

const fil_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Malapit Na`)
};

const fr_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bientôt disponible`)
};

const it_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossimamente`)
};

const hu_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hamarosan`)
};

const nl_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binnenkort`)
};

const no_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommer snart`)
};

const pl_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wkrótce`)
};

const pt_br2_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming Soon`)
};

const pt_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em breve`)
};

const ro_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`În curând`)
};

const fi_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tulossa pian`)
};

const sv_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommer snart`)
};

const vi_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp ra mắt`)
};

const tr_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çok Yakında`)
};

const cs_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Již brzy`)
};

const bg_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очаквайте скоро`)
};

const ru_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скоро`)
};

const uk_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Незабаром`)
};

const ar_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قريبًا`)
};

const hi_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जल्द आ रहा है`)
};

const th_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เร็ว ๆ นี้`)
};

const ja_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近日公開`)
};

const zh_cn2_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming Soon`)
};

const zh_hant1_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming Soon`)
};

const ko_components_offercard_comingsoon2 = /** @type {(inputs: Components_Offercard_Comingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming Soon`)
};

/**
* | output |
* | --- |
* | "Coming Soon" |
*
* @param {Components_Offercard_Comingsoon2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_offercard_comingsoon2 = /** @type {((inputs?: Components_Offercard_Comingsoon2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Offercard_Comingsoon2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_offercard_comingsoon2(inputs)
	if (locale === "ms") return ms_components_offercard_comingsoon2(inputs)
	if (locale === "da") return da_components_offercard_comingsoon2(inputs)
	if (locale === "de") return de_components_offercard_comingsoon2(inputs)
	if (locale === "en-US") return en_us2_components_offercard_comingsoon2(inputs)
	if (locale === "es-ES") return es_es2_components_offercard_comingsoon2(inputs)
	if (locale === "es-MX") return es_mx2_components_offercard_comingsoon2(inputs)
	if (locale === "fil") return fil_components_offercard_comingsoon2(inputs)
	if (locale === "fr") return fr_components_offercard_comingsoon2(inputs)
	if (locale === "it") return it_components_offercard_comingsoon2(inputs)
	if (locale === "hu") return hu_components_offercard_comingsoon2(inputs)
	if (locale === "nl") return nl_components_offercard_comingsoon2(inputs)
	if (locale === "no") return no_components_offercard_comingsoon2(inputs)
	if (locale === "pl") return pl_components_offercard_comingsoon2(inputs)
	if (locale === "pt-BR") return pt_br2_components_offercard_comingsoon2(inputs)
	if (locale === "pt") return pt_components_offercard_comingsoon2(inputs)
	if (locale === "ro") return ro_components_offercard_comingsoon2(inputs)
	if (locale === "fi") return fi_components_offercard_comingsoon2(inputs)
	if (locale === "sv") return sv_components_offercard_comingsoon2(inputs)
	if (locale === "vi") return vi_components_offercard_comingsoon2(inputs)
	if (locale === "tr") return tr_components_offercard_comingsoon2(inputs)
	if (locale === "cs") return cs_components_offercard_comingsoon2(inputs)
	if (locale === "bg") return bg_components_offercard_comingsoon2(inputs)
	if (locale === "ru") return ru_components_offercard_comingsoon2(inputs)
	if (locale === "uk") return uk_components_offercard_comingsoon2(inputs)
	if (locale === "ar") return ar_components_offercard_comingsoon2(inputs)
	if (locale === "hi") return hi_components_offercard_comingsoon2(inputs)
	if (locale === "th") return th_components_offercard_comingsoon2(inputs)
	if (locale === "ja") return ja_components_offercard_comingsoon2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_offercard_comingsoon2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_offercard_comingsoon2(inputs)
	return ko_components_offercard_comingsoon2(inputs)
});
export { components_offercard_comingsoon2 as "components.offerCard.comingSoon" }